/**
 * Wraps a setState function to call a side effect after the state update
 * @param setter - The setState function to wrap
 * @param sideEffect - Function to call with the new value after setState completes
 * @returns A wrapped setter that captures the new value and calls the side effect
 */
export function setterSideEffect<T>(
  setter: (updater: T | ((prev: T) => T)) => void,
  sideEffect: (newValue: T) => void,
): (updater: T | ((prev: T) => T)) => void {
  return (updater: T | ((prev: T) => T)) => {
    let newValue: T;
    setter((prev) => {
      newValue =
        typeof updater === 'function' ? (updater as any)(prev) : updater;
      return newValue;
    });
    sideEffect(newValue!);
  };
}
